import { render, staticRenderFns } from "./TagButtons.vue?vue&type=template&id=cf4e1b4c"
import script from "./TagButtons.vue?vue&type=script&lang=js"
export * from "./TagButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports